import { EmployeeEntity } from "modules/company/entities";
import { EmployeeRemoveModal } from "modules/company/features";
import { useMyPermissions } from "modules/my-permissions";
import React, { CSSProperties } from "react";
import { api, CompanyEmployeeDto } from "shared/api";
import { Modals } from "shared/lib";
import { IListData, List, MenuItem } from "shared/ui";

export interface IEmployeeList extends IListData<CompanyEmployeeDto> {
  companySlug: string;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const EmployeeList = (props: IEmployeeList) => {
  const roleList = api.companyRbac.useCompanyEmployeeRoleList(props.companySlug);
  const company = api.company.useCompanyGet(props.companySlug);

  const permissions = useMyPermissions(props.companySlug);

  const onRemove = (data: CompanyEmployeeDto) =>
    Modals.open(EmployeeRemoveModal, {
      data,
      companySlug: props.companySlug,
      onSuccess: () => props.mutate?.(),
    });

  return (
    <List
      {...props}
      renderItem={(it) => (
        <EmployeeEntity
          companySlug={props.companySlug}
          data={it}
          roles={roleList.data}
          companyOwnerId={company.data?.ownerUserId}
          readOnly={!permissions?.company.members.update}
          menuItems={
            permissions?.company.members.remove &&
            it.companyEmployeeRole.type !== "OWNER" && (
              <>
                <MenuItem type="error" onClick={() => onRemove(it)}>
                  Удалить из компании
                </MenuItem>
              </>
            )
          }
        />
      )}
    />
  );
};

EmployeeList.defaultProps = {};
